import { GameEvent } from '../events/gameEvent';
import { EventName } from '../events/eventsName';
import { SoundManager } from '../core/soundManager';
import { Store } from 'game/store/gameStore';
import { updateUIState, uiStore } from 'ui';
import { cloneDeep } from 'lodash';

export class AutocompleteButton {
    settingsOpen = false;
    autocompletePossible = false;
    autocompleteSound?: Howl;
    soundPlayed = false;
    status = 'no' as 'auto' | 'clicked' | 'no';
    autocompleteTriggered = false;

    constructor() {
        this.autocomplete = this.autocomplete.bind(this);
        this.refreshState = this.refreshState.bind(this);
        this.onAutocompleteFinish = this.onAutocompleteFinish.bind(this);
        GameEvent.add(EventName.TOGGLE_AUTOCOMPLETE, this.refreshState);
        GameEvent.add(EventName.AUTOCOMPLETE_COMPLETE, this.onAutocompleteFinish);

        document.addEventListener('ui-button-click', (customEvent: any) => {
            const { buttonKey } = customEvent.detail;

            if (buttonKey === 'autocomplete') {
                this.onAutocompleteButtonClick();
            }
        });
        window.addEventListener('autocomplete-button-click', this.onAutocompleteButtonClick.bind(this));
    }

    private onAutocompleteButtonClick() {
        uiStore.dispatch(updateUIState({
            buttons: {
                ...uiStore.getState().gameUI.buttons,
                showAutocomplete: false
            }
        }));

        this.autocomplete();
    }

    onAutocompleteFinish() {
        if (this.autocompleteSound) {
            this.autocompleteSound.on('fade', () => {
                this.autocompleteSound?.stop();
            });
            this.autocompleteSound.fade(1, 0, 1000);
        }
    }

    autocomplete() {
        this.status = Store.autocomplete ? 'auto' : 'clicked';
        this.autocompleteTriggered = true;

        if (Store.isKlondike) this.autocompleteSound = SoundManager.play('autocompleteRunSFX', { loop: true }).instance;
        if (Store.isFreecell) this.autocompleteSound = SoundManager.play('autocompleteRunSFX', { loop: true }).instance;

        GameEvent.emit(EventName.RUN_AUTOCOMPLETE);
        this.autocompletePossible = false;

        this.refreshState();
    }

    refreshState() {
        if (this.autocompleteTriggered) return;
        if (this.autocompletePossible && Store.autocomplete) {
            this.autocomplete();
            return;
        }
        //run autocomplete
        const show = this.autocompletePossible;

        if (show && !this.soundPlayed) {
            this.soundPlayed = true;
            SoundManager.play('autocompleteShowSFX');
        }

        console.log('showAutocomplete', show);
        uiStore.dispatch(updateUIState({
            ...cloneDeep(uiStore.getState().gameUI),
            buttons: {
                ...cloneDeep(uiStore.getState().gameUI.buttons),
                showAutocomplete: show
            }
        }));
    }

    changeVisibility(autoCompleteActive: boolean) {
        this.autocompletePossible = autoCompleteActive;
        this.refreshState();
    }

    reset() {
        this.autocompleteTriggered = false;
        this.soundPlayed = false;
        this.status = 'no';
    }
}
